import { createContext, useContext } from "react";

const FormFieldIdContext = createContext<string | undefined>(undefined);
export const FormFieldIdProvider = FormFieldIdContext.Provider;
export const useFormFieldId = () => useContext(FormFieldIdContext);

/**
 * Id of the `<label>` element belonging to a form field id. Fields that are
 * not labelable elements (e.g. a contenteditable div, which `htmlFor` cannot
 * associate with) reference the label via `aria-labelledby` instead.
 */
export const formFieldLabelId = (fieldId: string) => `${fieldId}-label`;
